import { useMemo } from "react";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useTRPC } from "../../../../trpc/client";
import { mapMovementSourceType } from "../mappers/payouts.mapper";
import type { LedgerFiltersType } from "../types/payouts.type";
import { useQuery } from "@tanstack/react-query";

export function useFetchLedger(
  filters: LedgerFiltersType = {},
  cursor?: string
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const queryInput = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      cursor,
      sourceTypes:
        filters.sourceType &&
        mapMovementSourceType[
          filters.sourceType as keyof typeof mapMovementSourceType
        ]
          ? [
              mapMovementSourceType[
                filters.sourceType as keyof typeof mapMovementSourceType
              ],
            ]
          : undefined,
      createdAtRange: filters.dateRange
        ? ([
            `${filters.dateRange[0]}T00:00:00.000`,
            `${filters.dateRange[1]}T23:59:59.999`,
          ] as [string, string])
        : undefined,
      sourceId:
        filters.sourceId && filters.sourceId.trim() !== ""
          ? filters.sourceId
          : undefined,
    }),
    [merchant?.id, cursor, filters]
  );

  const { data, isLoading, refetch } = useQuery(
    trpc.ledgerMovements.list.queryOptions(queryInput, {
      enabled: !!merchant?.id,
    })
  );

  const ledger = data?.data || [];
  const nextCursor = data?.cursor || undefined;
  const totalItems = data?.length || 0;

  return {
    ledger,
    nextCursor,
    totalItems,
    isLoading,
    refetch,
  };
}
